var inviteeEmailViewUrl = require('./invitee-email-view.html');

var DataList = require('../../../shared').DataList;

e360.controller('EventDataController', [
   '$scope',
   'session',
   'emailApi',
   'participantsApi',
   'preregApi',
   'inviteesApi',
   'mediaApi',
   'surveyItemsApi',
   '$state',
   'utils',
   'dialogs',
   '$uibModal',
   'toast',
   'filterServiceFactory',
   'fileDownload',
   '$timeout',
   'loader',
   'titleService',
   'apiHelper',
   'experiencesService',
   'eventLocationFilter',

   function ($scope, session, emailApi, participantsApi, preregApi, inviteesApi, mediaApi, surveyItemsApi, $state,
             utils, dialogs, $modal, toast, filterServiceFactory, fileDownload, $timeout, loader, titleService, apiHelper,
             experiencesService, eventLocation) {

      var locals = {};
      var resultType = $state.current.url.replace('/', '');

      $scope.filter = new filterServiceFactory({
         key: resultType,
         defaults: {
            campaignId: session.getCampaign().id,
            orderBy: '-created',
            page: 1,
            limit: 20
         },
         properties: ['search', 'eventId', 'startDate', 'endDate'],
         callback: function(property) {
            $scope.refresh(property);
         }
      });

      $scope.model = new DataList();

      locals.columns = {
         'firstName': {title: 'First', sortable: true, collapsable: false},
         'lastName': {title: 'Last', sortable: true, collapsable: false},
         'email': {title: 'Email', sortable: true, collapsable: true},
         'event.name': {
            title: 'Event', sortable: true, collapsable: false, cls: 'hidden-xs', label: function (row) {
               return row.event.name;
            }
         },
         'event.startDate': {
            title: 'Event Date',
            sortable: true,
            cls: 'hidden-xs hidden-sm hidden-md',
            collapsable: true,
            label: function (row) {
               return utils.formatDate(row.event.startDateTime);
            }
         },
         'event.state.code,event.cityName': {
            title: 'Location', sortable: true, collapsable: true, cls: 'hidden-xs hidden-sm', label: function (row) {
               return eventLocation(row.event);
            }
         },
         'guestType.name': {
            title: 'Guest Type',
            sortable: true,
            collapsable: true,
            cls: 'hidden-xs hidden-sm hidden-md',
            label: function(row) {
               if (row.guestType !== null) {
                  return row.guestType.name;
               }

               return 'General';
            }
         },
         get: function (key) {
            var column = this[key];
            column.key = key;
            return column;
         }
      };

      $scope.resultTypes = [
         {
            key: 'participants',
            title: 'Participants',
            exportKey: 'participant',
            api: participantsApi,
            columns: [
               locals.columns.get('firstName'),
               locals.columns.get('lastName'),
               {
                  key: 'phoneMobile',
                  title: 'Phone',
                  sortable: true,
                  collapsable: true,
                  cls: 'hidden-xs hidden-sm hidden-md'
               },
               locals.columns.get('email'),
               locals.columns.get('guestType.name'),
               locals.columns.get('event.name'),
               locals.columns.get('event.startDate'),
               locals.columns.get('event.state.code,event.cityName'),
               {
                  key: 'created',
                  title: 'Created',
                  sortable: true,
                  collapsable: true,
                  cls: 'hidden-xs',
                  label: function (row) {
                     return utils.formatDate(row.created);
                  }
               }
            ],
            tabs: [
               {
                  title: 'Details',
                  key: 'details',
                  templateUrl: 'participant-details-tab.html',
                  icon: 'fa fa-list-alt'
               },
               {title: 'Notes', key: 'notes', templateUrl: 'notes-tab.html', icon: 'fa fa-file-text-o'}
            ],
            getTabs: function (result) {
               var tabs = this.tabs;

               if (result.surveyResults && result.surveyResults.length > 0) {
                  tabs = tabs.concat({
                     title: 'Survey Answers',
                     key: 'surveyAnswers',
                     templateUrl: 'participant-survey-answers.html',
                     icon: 'fa fa-question'
                  });
               }

               if (result.filesOfType('image').length > 0) {
                  tabs = tabs.concat({
                     title: 'Photos',
                     key: 'photos',
                     templateUrl: 'participant-photos.html',
                     icon: 'fa fa-camera'
                  });
               }

               if (result.filesOfType('video').length > 0) {
                  tabs = tabs.concat({
                     title: 'Videos',
                     key: 'videos',
                     templateUrl: 'participant-videos.html',
                     icon: 'fa fa-film'
                  });
               }

               if (result.filesOfType('pdf').length > 0) {
                  tabs = tabs.concat({
                     title: 'Documents',
                     key: 'documents',
                     templateUrl: 'participant-documents.html',
                     icon: 'fa fa-file-text'
                  });
               }

               return tabs;
            },
            getAddUrl: function () {
               return 'event.addParticipant({eventId:getEventId()})';
            },
            getEditUrl: function (row) {
               return `event.editParticipant({id: ${row.id}})`;
            }
         },
         {
            key: 'prereg',
            title: 'Pre-registrations',
            exportKey: 'prereg',
            api: preregApi,
            columns: [
               locals.columns.get('firstName'),
               locals.columns.get('lastName'),
               locals.columns.get('email'),
               {
                  key: 'created',
                  title: 'Created',
                  sortable: true,
                  collapsable: true,
                  cls: 'hidden-xs',
                  label: function (row) {
                     return utils.formatDate(row.created);
                  }
               },
               locals.columns.get('event.name'),
               locals.columns.get('event.startDate'),
               locals.columns.get('event.state.code,event.cityName'),
               {
                  key: 'Confirmed',
                  title: 'Status',
                  sortable: true,
                  collapsable: true,
                  cls: 'hidden-xs',
                  label: function (row) {
                     return $scope.getStatus(row);
                  }
               },
               {
                  key: 'isGuest,guestType.name',
                  title: 'Guest Type',
                  sortable: true,
                  collapsable: true,
                  cls: 'hidden-xs hidden-sm hidden-md',
                  label: function(row) {
                     var type = $scope.getType(row);
                     if (row.guestType !== null) {
                        return type + ' ' + row.guestType.name;
                     }

                     return type + ' General';
                  }
               },
               {key: 'guestCount', title: '# Secondaries', sortable: false, collapsable: true, cls: 'hidden-xs hidden-sm'}
            ],
            tabs: [
               {title: 'Details', key: 'details', templateUrl: 'prereg-details-tab.html', icon: 'fa fa-list-alt'},
               {title: 'Notes', key: 'notes', templateUrl: 'notes-tab.html', icon: 'fa fa-file-text-o'}
            ],
            getTabs: function (result) {
               if (result) {
                  var tabs = this.tabs.concat();//make a copy

                  if (!result.isGuest) {
                     tabs = tabs.concat({
                        title: 'Secondary Guests',
                        key: 'guests',
                        templateUrl: 'prereg-guests-tab.html',
                        icon: 'fa fa-users'
                     });
                  }

                  if (result.surveyItems && result.surveyItems.length > 0) {
                     tabs = tabs.concat({
                        title: 'Survey Answers',
                        key: 'surveyItems',
                        templateUrl: 'prereg-survey-items.html',
                        icon: 'fa fa-question'
                     });
                  }

                  return tabs;
               }
               return this.tabs;
            },
            getAddUrl: function () {
               return 'event.addPreReg({eventId: getEventId()})';
            },
            getEditUrl: function (row) {
               var stateRef = (row.isGuest) ? 'event.editGuest' : 'event.editPreReg';
               return stateRef + `({id: ${row.id}})`;
            }
         },
         {
            key: 'invitees',
            title: 'Invitees',
            exportKey: 'invitee',
            api: inviteesApi,
            columns: [
               locals.columns.get('firstName'),
               locals.columns.get('lastName'),
               locals.columns.get('email'),
               locals.columns.get('guestType.name'),
               {
                  key: 'created', title: 'Created',
                  sortable: true, collapsable: true, cls: 'hidden-xs',
                  label: function (row) {
                     return utils.formatDate(row.created);
                  }
               },
               locals.columns.get('event.name'),
               locals.columns.get('event.startDate'),
               locals.columns.get('event.state.code,event.cityName')
            ],
            tabs: [{
               title: 'Details',
               key: 'details',
               templateUrl: 'invitee-details-tab.html',
               icon: 'fa fa-list-alt'
            }],
            getTabs: function (result) {
               return this.tabs;
            },
            getAddUrl: function () {
               return 'event.addInvitee({eventId: getEventId()})';
            },
            getEditUrl: function (row) {
               return `event.editInvitee({id: ${row.id}})`;
            }
         }
      ];

      locals.initialize = function () {
         if (!session.getCampaign()) {
            return;
         }

         $scope.loader = loader;

         // google: angularjs dot rule
         // needed isDetailsBusy flag on an object to work with tab directive
         // isolate scope, if/when controllerAs syntax is adopted remove this
         $scope.vm = { isDetailsBusy: false, activeTab: 0 };
         $scope.columns = [];
         $scope.defaultLanguage = session.getCampaign().defaultLanguage;
         $scope.apiDomain = session.apiDomain();

         locals.initResultType();

         $scope.$on('import.complete', $scope.refresh);

         titleService.setTitle($scope.selectedResultType.title);

         // Check if certain email experiences exist
         experiencesService.list(session.getCampaign().id).then(function (experiences) {
            _.each(experiences, function(exp) {
               if (experiencesService.isEmail(exp.type)) {
                  if (exp.settings.emailName === 'RsvpConfirm') {
                     $scope.hasConfirmationEmail = true;
                  } else if (exp.settings.emailName === 'RsvpReminder') {
                     $scope.hasReminderEmail = true;
                  } else if (exp.settings.emailName === 'WebinarReminder') {
                     $scope.hasWebinarEmail = true;
                  } else if (exp.settings.emailName === 'RsvpGuestInvite') {
                     $scope.hasGuestInviteEmail = true;
                  } else if (exp.settings.emailName === 'RsvpInvite') {
                     $scope.hasInviteEmail = true;
                  }
               }
            });
         });

         $scope.refresh();
      };

      locals.initResultType = function () {
         var key = $state.current.url.replace('/', '');
         var resultType = _.findWhere($scope.resultTypes, {key: key});
         $scope.selectedResultType = resultType;
         $scope.setColumns();
      };

      locals.getApi = function () {
         return $scope.selectedResultType.api;
      };

      $scope.getTabClass = function (tab) {
         if ($scope.selectedDetailsTab && tab.key === $scope.selectedDetailsTab.key) {
            return 'selected';
         }
         return '';
      };

      $scope.getTableCellValue = function (row, column) {
         var value;
         if (column.label) {
            try {
               value = column.label(row);
            } catch (e) {
               value = '';
            }
         } else {
            value = row[column.key];
         }

         return value;
      };

      $scope.setColumns = function () {
         var columns = $scope.selectedResultType.columns;
         if ($scope.model.selected) {
            $scope.columns = columns.filter(function (column) {
               return !column.collapsable;
            });
         } else {
            $scope.columns = columns;
         }
      };

      $scope.exportCsv = function(format) {
         loader.showMessage(
            'We are preparing your export',
            'This may take several moments if there are a lot of records.'
         );

         var params = angular.copy($scope.filter.inputs);
         params.format = format;

         new fileDownload(apiHelper.getApiUrl('export/' + $scope.selectedResultType.exportKey), params)
            .get().then(function() {
               loader.hide();
            });
      };

      $scope.isInvitees = function () {
         return $scope.selectedResultType.key == 'invitees';
      };

      $scope.select = function ($event, result) {
         // ignore clicks on duplicate/edit/copy actions
         if (!angular.element($event.target).parents('td').hasClass('actions')) {
            $scope.model.selected = result;
            $scope.setColumns();
            $scope.getDetail(result);
         }
      };

      $scope.collapse = function () {
         $scope.clearSelection();
      };

      $scope.clearSelection = function () {
         $scope.detailsTabs = null;
         $scope.selectedDetailsTab = null;
         $scope.model.selected = null;
         $scope.setColumns();
      };

      $scope.selectDetailsTab = function (tab) {
         $scope.selectedDetailsTab = tab;
      };

      $scope.getTimeSlotLabel = function () {
         if ($scope.model.selected) {
            var timeSlot = $scope.model.selected.timeSlot,
               label = '';
            if (timeSlot) {
               if (timeSlot.name) {
                  label += timeSlot.name + ' ';
               }
               label += utils.formatDate(timeSlot.startDateTime, 'M/D/YYYY - h:mma');
            }
            return label;
         }
         return '';
      };

      $scope.getEditUrl = function (row) {
         return $scope.selectedResultType.getEditUrl(row);
      };

      $scope.getEventId = function() {
         if ($scope.filter.eventId && $scope.filter.eventId.length == 1)
            return $scope.filter.eventId[0];
      };

      $scope.getAddUrl = function () {
         return $scope.selectedResultType.getAddUrl();
      };

      $scope.getTitle = function (result) {
         if (result) {
            if (result.firstName) {
               var output = result.firstName;
               if (result.lastName) {
                  output += ' ' + result.lastName;
               }
               return output;
            }
            if (result.email) {
               return result.email;
            }
         }
         return 'Details';
      };

      $scope.getStatus = function (row) {
         return (row && row.isConfirmed) ? 'Confirmed' : 'Unconfirmed';
      };

      $scope.getType = function (row) {
         return row.isGuest ? 'Secondary' : 'Primary';
      };

      $scope.getGenderText = function (gender) {
         switch (gender) {
            case 'M':
               return 'Male';
            case 'F':
               return 'Female';
         }
         return '';
      };

      $scope.remove = function (result) {
         dialogs.confirm('Are you sure you want to delete this result?').then(function () {
            loader.showSpinner();

            locals.getApi().del(result.id).then(function () {
               loader.hide();
               toast.success()
                  .message('Result deleted!')
                  .send();
               $scope.clearSelection();
               $scope.filter.page = 1;
               $scope.refresh();
            });
         });
      };

      $scope.removeBulk = function () {
         if (!session.isSuperAdmin()) {
            return;
         }

         var ids = $scope.model.checkedIds;

         dialogs.confirm('Are you sure you want to delete ' + ids.length + ' ' + $scope.selectedResultType.title.toLowerCase() + '?').then(function () {
            loader.showSpinner();

            locals.getApi().del(ids).then(function () {
               toast.success()
                  .message(ids.length + ' ' + $scope.selectedResultType.title.toLowerCase() + ' deleted!')
                  .send();
               $scope.clearSelection();
               $scope.filter.page = 1;
               return $scope.refresh();
            }).finally(function () {
               loader.hide();
            });
         });
      };

      $scope.refresh = function (filterProperty) {
         // clear selection before refresh to avoid JS ref errors in side panel templates
         $scope.clearSelection();

         loader.showSpinner();

         return locals.getApi().list($scope.filter.inputs).then(function (data) {
            $scope.model.setList(data.list, data.total);
            if (filterProperty !== 'page') {
               $scope.model.checkedIds = [];
            }

            // fetch survey items for use in the participant details panel
            return surveyItemsApi.list(session.getBrand().id);
         }).then(function (surveyItems) {
            locals.surveyItems = surveyItems;
         }).finally(function () {
            loader.hide();
         });
      };

      $scope.getDetail = function (result) {
         $scope.vm.isDetailsBusy = true;

         locals.getApi().get(result.id).then(function (data) {
            // populate survey result value with choice description/label
            function formatResultValue(item, val) {
               if (item.type == 'Option') {
                  var choice = _.findWhere(item.surveyItemChoices, {key: val});

                  // choice could have been deleted after survey result created
                  if (choice) {
                     val = choice.label[$scope.defaultLanguage];
                  }
               } else if (item.type == 'Multioption') {
                  var answers = val.split(',');

                  var choices = _.chain(item.surveyItemChoices)
                     .filter(function (c) { return _.contains(answers, c.key); })
                     .map(function (c) { return c.label[$scope.defaultLanguage]; })
                     .value();

                  // don't show inaccurate result if any choices were deleted
                  if (choices.length == answers.length) {
                     val = choices.join(',');
                  }
               }

               return val;
            }

            // participants have `surveyResults`
            if (data.surveyResults) {
               _.each(data.surveyResults, function (r) {
                  // result value should never be null for option/multioption
                  // except when it is, so avoid null ref errors
                  if (r.value === null) {
                     return;
                  }

                  var item = _.findWhere(locals.surveyItems, {id: r.surveyItem.id});
                  r.value = formatResultValue(item, r.value);
               });
            }

            // pre-registrations have `surveyItems`
            if (data.surveyItems) {
               _.each(data.surveyItems, function (r) {
                  var item = _.findWhere(locals.surveyItems, {key: r.name});
                  if (item) {
                     r.value = formatResultValue(item, r.value);
                  }
               });
            }

            /*
             If you click around fast enough, it causes the selection to jump around.
             This condition ensures we have the data for the currently selected item to avoid that.
             */
            if ($scope.model.selected.id === data.id) {
               $scope.model.selected = data;
               $scope.detailsTabs = $scope.selectedResultType.getTabs(data);
               $scope.vm.isDetailsBusy = false;

               if ($scope.selectedResultType.key === 'prereg') {
                  var endDate = data.event.endDateTime;
                  if (data.timeSlot) {
                     endDate = data.timeSlot.endDateTime;
                  }

                  data.futureEvent = utils.toServerMoment(endDate).isAfter(moment());
               }

               // need a moment for the ngRepeat to finish iterating details tabs
               // otherwise the ui-tabset directive won't select first tab
               $timeout(function() {
                  $scope.vm.activeTab = 0;
               });
            }
         });
      };

      $scope.showInviteEmailDialog = function () {
         var modal = $modal.open({
            templateUrl: inviteeEmailViewUrl,
            controller: 'InviteeEmailController',
            backdrop: 'static',
            size: 'md',
            resolve: {
               emailParams: function() {
                  return angular.extend({idsOnly: true}, $scope.filter.inputs);
               }
            }
         });

         modal.result.then(function (result) {
            var params = {
               campaignId: session.getCampaign().id,
               inviteeIds: result.ids,
               deployName: result.deployName
            };

            if (session.isSuperAdmin() && result.template) {
               params.template = result.template;
            }

            loader.showSpinner();
            emailApi.sendInvites(params).then(function () {
               loader.hide();
               toast.success()
                   .message('Invite emails sent')
                   .send();
            }, function (e) {
               loader.hide();
               toast.error()
                   .message('Error sending invite emails, please create bug report')
                   .send();
            });
         });
      };

      $scope.sendEmail = function(preregId, name) {
         var emails = {
            'confirmation': 'RsvpConfirm',
            'reminder': 'RsvpReminder',
            'webinar': 'WebinarReminder',
            'guest invite': 'RsvpGuestInvite'
         }, emailName = emails[name];

         var modalScope = $scope.$new(true);
         modalScope.name = name;

         var modal = $modal.open({
            templateUrl: 'prereg-email-dialog.html',
            scope: modalScope,
            size: 'sm'
         });

         modal.result.then(function() {
            loader.showSpinner();
            preregApi.sendEmail(preregId, emailName).then(function() {
               loader.hide();
               toast.success()
                  .message('Email sent')
                  .send();
            }, function(e) {
               loader.hide();
               toast.error()
                  .message('Error sending email')
                  .send();
            });
         });
      };

      $scope.saveNotes = function () {
         $scope.savingNotes = true;
         locals.getApi().update($scope.model.selected).then(function () {
            toast.success()
               .message('Notes saved!')
               .send();
         })['finally'](function () {
            $scope.savingNotes = false;
         });
      };

      $scope.openVideo = function(video) {
         $modal.open({
            animation: true,
            templateUrl: 'view-participant-video-modal.html',
            controller: 'ViewParticipantVideoController',
            resolve: { video: video }
         });
      };

      $scope.downloadFile = function(file) {
         loader.showSpinner();
         mediaApi.download(file).then(function() {
            loader.hide();
         });
      };

      locals.initialize();
   }
]);

e360.controller('ViewParticipantVideoController',
   ['$scope', '$sce', '$uibModalInstance', 'video',
      function($scope, $sce, $modalInstance, video) {
         $scope.link = $sce.trustAsResourceUrl('//www.youtube.com/embed/' + video.youTubeID + '?autoplay=1');

         $scope.close = function() {
            $modalInstance.dismiss();
         };
      }
   ]
);
